import { FALLBACK_SIZE, FALLBACK_FORMAT } from '../constants';
export const getEpsImageUrlFromParts = ({ protocol, baseUrl, zoomId, size = FALLBACK_SIZE, suffix = FALLBACK_FORMAT, queryString = '' }) => `${protocol}${baseUrl}/images/g/${zoomId}/s-l${size}.${suffix}${queryString}`;
